import React from 'react';
import PropTypes from 'prop-types';

import MInputField from '../../molecules/fields/_molecules.input-field';

export default function OContactFormBasic({
	familyName,
	name,
	telephone,
	email,
	onFamilyNameChange,
	onNameChange,
	onTelephoneChange,
	onEmailChange,
}) {
	return (
		<article className="o-contact-basic">
			<MInputField
				id="iFamilyName"
				label="FORM.FAMILY_NAME"
				value={familyName}
				placeholder="Doe"
				required
				onChange={onFamilyNameChange}
			/>
			<MInputField
				id="iName"
				label="FORM.FIRST_NAME"
				value={name}
				placeholder="John"
				required
				onChange={onNameChange}
			/>
			<MInputField
				id="iTel"
				type="tel"
				label="FORM.PHONE"
				value={telephone}
				placeholder="0491 23 45 67"
				required
				onChange={onTelephoneChange}
			/>
			<MInputField
				id="iEmail"
				type="email"
				label="FORM.EMAIL"
				value={email}
				placeholder="johndoe@gmail.com"
				required
				onChange={onEmailChange}
			/>
		</article>
	);
}

OContactFormBasic.propTypes = {
	familyName: PropTypes.string,
	name: PropTypes.string,
	telephone: PropTypes.string,
	email: PropTypes.string,
	onFamilyNameChange: PropTypes.func,
	onNameChange: PropTypes.func,
	onTelephoneChange: PropTypes.func,
	onEmailChange: PropTypes.func,
};

OContactFormBasic.defaultProps = {
	familyName: undefined,
	name: undefined,
	telephone: undefined,
	email: undefined,
	onFamilyNameChange: undefined,
	onNameChange: undefined,
	onTelephoneChange: undefined,
	onEmailChange: undefined,
};




// WEBPACK FOOTER //
// ./src/components/organisme/contact/_organisme.contact-basic.js